import { changeTitle } from "../changeTitle";

const useChangeTitle = (title: string) => {
  changeTitle(title, "default");
};

export default useChangeTitle;
